import React from "react";
import { CircularProgress, Grid } from "@mui/material";
import { MembersProvider } from "src/scenes/teams/members-provider";
import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import ManagePlanListsWrapper from "src/scenes/subscription/manage-plan-lists-wrapper";
import Flex from "../../components/flex";
import useSubscriptionApi from "./use-subscription-api";
import fetchStatus from "../../utils/api/fetch-status";
import Auth from "../../services/auth";
import { useAuth } from "../../components/providers/auth-context";
import SubscriptionCard from "./subscription-card";
import PaymentDetailsCard from "./payment-details-card";

const Subscription = () => {
    const { idToken } = useAuth();
    const [subscription, setSubscription] = React.useState();
    const [membersAlreadyInPlan, setMembersAlreadyInPlan] = React.useState();
    const subscriptionApi = useSubscriptionApi();

    React.useEffect(() => {
        if (subscriptionApi.data) {
            const team = subscriptionApi.data.find(
                (sub) => sub.subscription.type === "team" || sub.subscription.type === "enterprise"
            );
            const personal = subscriptionApi.data.find(
                (sub) => sub.subscription.type === "personal"
            );
            if (team) {
                setSubscription(team);
            } else if (personal) {
                setSubscription(personal);
            } else {
                setSubscription({ subscription: { type: "free" } });
            }
        }
    }, [subscriptionApi.data]);

    if (subscriptionApi.status === fetchStatus.ERROR && subscriptionApi.errorCode === 404)
        return <Navigate to="/upgrade" replace />;

    if (subscriptionApi.status === fetchStatus.SUCCESS) {
        if (!idToken.plans || idToken.plans.length !== subscriptionApi.data.length) {
            Auth.relog();
            return <CircularProgress size={150} />;
        }
    }
    if (subscriptionApi.status === fetchStatus.SUCCESS && subscriptionApi.data.length === 0)
        return <Navigate to="/upgrade" replace />;

    const isEnterpriseUser = subscription && subscription.subscription.type === "enterprise";
    const isUserPlanAdmin = subscription && subscription.subscription.isAdmin;

    return (
        <div style={{ maxWidth: "800px" }}>
            <Helmet>
                <title>Adadot - Subscription</title>
            </Helmet>

            <Grid container direction="row">
                <Grid item direction="row">
                    <Flex
                        width="100%"
                        justifyContent="space-around"
                        margin={["32px", 0, "32px", 0]}
                    >
                        <Grid container spacing={5} justifyContent="space-between">
                            <Grid item style={{ paddingTop: "0" }}>
                                <SubscriptionCard
                                    subscription={subscription && subscription.subscription}
                                    membersAlreadyInPlan={membersAlreadyInPlan}
                                    isEnterpriseUser={isEnterpriseUser}
                                    isUserPlanAdmin={isUserPlanAdmin}
                                />
                            </Grid>
                            {isUserPlanAdmin && (
                                <Grid item style={{ paddingTop: "0" }}>
                                    <PaymentDetailsCard
                                        subscriptionApi={subscriptionApi}
                                        paymentMethod={subscription && subscription.paymentMethod}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Flex>
                    <MembersProvider>
                        <ManagePlanListsWrapper
                            subscription={subscription && subscription.subscription}
                            membersAlreadyInPlan={subscription && membersAlreadyInPlan}
                            setMembersAlreadyInPlan={subscription && setMembersAlreadyInPlan}
                        />
                    </MembersProvider>
                </Grid>
            </Grid>
        </div>
    );
};

export default Subscription;
